export interface EligibleStorageProduct {
  id: number;
  name: string;
  code: string;
}

export interface EligibleStorageTeam {
  id: number;
  name: string;
}

export interface EligibleStorageCalculationBase {
  price_per_m3?: number;
  total_volume_m3?: number;
  quantity?: number;
  period?: string;
  width_m?: number;
  height_m?: number;
  length_m?: number;
  unit_volume_m3?: number;
  [key: string]: any; // Permite otras propiedades dinámicas
}

export interface EligibleStorageTaxes {
  tax_rate?: number;
  [key: string]: any; // Permite otras propiedades dinámicas
}

export interface EligibleStorage {
  id: number;
  team_id: number;
  product_id: number;
  storage_date: string;
  period: string;
  width_m: number;
  height_m: number;
  length_m: number;
  unit_volume_m3: number;
  quantity: number;
  total_volume_m3: number;
  applied_rate: string | null;
  calculation_base: EligibleStorageCalculationBase;
  base_amount: number;
  taxes: EligibleStorageTaxes;
  total_amount: number;
  preinvoice_id: number | null;
  invoice_id: number | null;
  product: EligibleStorageProduct | null;
  team: EligibleStorageTeam | null;
}

export interface EligibleStorageFilters {
  searchFilter?: { filters: any[]; logic: string };
  search?: string;
  date_from?: string;
  date_to?: string;
  product_id?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  page?: number;
  limit?: number;
}

export interface EligibleStoragePage {
  storages: EligibleStorage[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export type FinancialStatus = 'pending' | 'preinvoiced' | 'invoiced' | 'blocked';

export const getFinancialStatus = (
  storage: EligibleStorage
): FinancialStatus => {
  if (storage.invoice_id) return 'invoiced';
  if (storage.preinvoice_id) return 'preinvoiced';
  return 'pending';
};

// Storage bloqueado - respuesta de GET /api/v1/invoices/storages/block
export interface BlockedStorage {
  id: number; // ID del registro de bloqueo (accounting_storage_blocks.id)
  storage_id: number;
  storage_block_reason_id: number;
  comment: string;
  user_id: number;
  created_at?: string;
  // Relaciones opcionales (pueden venir de la API)
  storage_block_reason?: {
    id: number;
    name: string;
    description?: string;
  };
  // La API también puede devolver 'reason' directamente
  reason?: {
    id: number;
    name: string;
    description?: string;
  };
  user?: {
    id: number;
    name: string;
    email?: string;
  };
  // Datos del storage relacionado (si la API los incluye)
  storage?: EligibleStorage;
  // Datos del producto y team (si la API los incluye)
  product?: EligibleStorageProduct;
  team?: EligibleStorageTeam;
}

// Respuesta paginada de la API para storages bloqueados
export interface BlockedStoragesPage {
  blockedStorages: BlockedStorage[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}
